import * as React from 'react';
import {AccountPlanRelationshipFormContainer} from '../../components/alderaan/accountPlans/AccountPlanRelationshipFormContainer'; // from '../../components/alderaan/plans/AccountPlanFormContainer';

function AccountPlanRelationshipForm(props) : JSX.Element{
  return <AccountPlanRelationshipFormContainer {...props} />;
}

export default AccountPlanRelationshipForm;